import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import ProductLines from "@/components/ProductLines";
import PackagingShowcase from "@/components/PackagingShowcase";
import Differentiation from "@/components/Differentiation";
import ProcessFlow from "@/components/ProcessFlow";
import ExecutionData from "@/components/ExecutionData";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-forest text-cream overflow-clip">
      <Navbar />
      <Hero />
      <PackagingShowcase />
      <Marquee />
      <Manifesto />
      <ProductLines />
      <Differentiation />
      <ProcessFlow />
      <ExecutionData />
      <Contact />
      <Footer />
    </main>
  );
}
